export default __webpack_public_path__ + "static/statusBar-0d34116f1cc77e7f9803c92505e15413.gif";